import type { QueryFunctionContext } from '@tanstack/react-query';
import { getMarketSummaries } from '@simplywallst/services';
import type { getMarketSummary } from '@simplywallst/services';
import type { VirtualNode } from '@components/VirtualRenderer/types';
type MarketSummaryTemplate = Parameters<typeof getMarketSummary>[0];
export const MARKET_SUMMARY_QUERY_KEY = 'market-summary';

export type BriefSentiment = 'good' | 'average' | 'bad' | null;
export type MarketSummary = {
  readonly text: string;
  readonly virtual: VirtualNode[];
  readonly sentiment: BriefSentiment;
};
export type MarketSummaries = Record<
  MarketSummaryTemplate,
  {
    readonly text: string;
    readonly virtual: VirtualNode[];
    readonly sentiment: BriefSentiment;
  }
>;

type QueryContext = QueryFunctionContext<[string, string, number]>;

export const getMarketSummaryQueryKey = (
  market: string,
  industry: number
): [string, string, number] => [MARKET_SUMMARY_QUERY_KEY, market, industry];

export async function fetchMarketSummary({
  queryKey: [_, market, industry],
}: QueryContext): Promise<MarketSummaries | undefined> {
  try {
    const {
      data: { data },
    } = await getMarketSummaries(market, industry.toString());

    return data;
  } catch (error: any) {
    console.error(`Error fetching market summary text: ${error.message}`);
    throw new Error(error.message);
  }
}
